export default [
  {
    path: "/platformConfigurations/currencies",
    component: () => import(/* webpackChunkName: "layout" */ "./layout"),

    children: [
      {
        path: "/",
        props: true,
        name: "platform.currencies",
        component: () => import(/* webpackChunkName: "platform.cashoutMethods" */ "./index.vue"),
      },
    ],
  },
];
